import { DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlSendLoadListenerTable extends Layout {
    sourceMCSendLoadListener: DataSource;
    tableMCSendLoadListener: Table;
    textboxTableName: Textbox;
    textboxDisplayName: Textbox;
}
